{
    "version": 8,
    "id": "klokantech-basic",
    "name": "Klokantech Basic",
    "metadata": {
        "mapbox:autocomposite": false,
        "mapbox:type": "template",
        "maputnik:renderer": "mbgljs",
        "openmaptiles:version": "3.x",
        "openmaptiles:mapbox:owner": "openmaptiles",
        "openmaptiles:mapbox:source:url": ""
    },
    "sources": {
        "openmaptiles": {
            "type": "vector",
            "tiles": ["https://maps.rosslyoung.com/data/v3/{z}/{x}/{y}.pbf"],
            "maxzoom": 14
        }
    },
    "glyphs": "https://maps.rosslyoung.com/fonts/{fontstack}/{range}.pbf",
    "sprite": "https://maps.rosslyoung.com/styles/osm/sprite",
    "layers": [
        {
            "id": "background",
            "type": "background",
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "background-color": "hsl(47, 26%, 88%)"
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landuse-residential",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landuse",
            "filter": [
                "all",
                ["==", "$type", "Polygon"],
                ["==", "class", "residential"]
            ],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(47, 13%, 86%)",
                "fill-opacity": 0.7
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landcover_grass",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landcover",
            "filter": ["==", "class", "grass"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(82, 46%, 72%)",
                "fill-opacity": 0.45
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "park",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "park",
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "rgba(192, 216, 151, 0.53)",
                "fill-opacity": 1
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landcover_wood",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landcover",
            "filter": ["==", "class", "wood"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(82, 46%, 72%)",
                "fill-opacity": {
                    "base": 1,
                    "stops": [[8, 0.6], [22, 1]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "water",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "water",
            "filter": ["==", "$type", "Polygon"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(205, 56%, 73%)"
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landcover-ice-shelf",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landcover",
            "filter": ["==", "subclass", "ice_shelf"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(47, 26%, 88%)",
                "fill-opacity": 0.8
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landcover-glacier",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landcover",
            "filter": ["==", "subclass", "glacier"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "hsl(47, 22%, 94%)",
                "fill-opacity": {
                    "base": 1,
                    "stops": [[0, 1], [8, 0.5]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landuse",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landuse",
            "filter": ["==", "class", "agriculture"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "#eae0d0"
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "landuse_overlay_national_park",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "landcover",
            "filter": ["==", "class", "national_park"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "#E1EBB0",
                "fill-opacity": {
                    "base": 1,
                    "stops": [[5, 0], [9, 0.75]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "park_outline",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "park",
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "line-color": "rgba(159, 183, 118, 0.69)",
                "line-dasharray": [0.5, 1]
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "waterway",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "waterway",
            "filter": ["==", "$type", "LineString"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "line-color": "hsl(205, 56%, 73%)",
                "line-width": {
                    "base": 1.4,
                    "stops": [[8, 1], [20, 8]]
                },
                "line-opacity": 1
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "building",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "building",
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "rgba(222, 211, 190, 1)",
                "fill-outline-color": {
                    "stops": [
                        [15, "rgba(212, 177, 146, 0)"],
                        [16, "rgba(212, 177, 146, 0.5)"]
                    ]
                },
                "fill-opacity": {
                    "base": 1,
                    "stops": [[13, 0], [20, 1]]
                },
                "fill-antialias": true
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "housenumber",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "housenumber",
            "minzoom": 17,
            "filter": ["==", "$type", "Point"],
            "layout": {
                "visibility": "visible",
                "text-field": "{housenumber}",
                "text-size": 10,
                "text-font": [
                    "Klokantech Noto Sans Regular",
                    "Open Sans Regular"
                ]
            },
            "paint": {
                "text-color": "rgba(212, 177, 146, 1)"
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_path",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["in", "class", "path", "track"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "square",
                "line-join": "bevel"
            },
            "paint": {
                "line-color": "hsl(0, 0%, 97%)",
                "line-dasharray": [1, 1],
                "line-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 10]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_minor",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["in", "class", "minor", "service"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "hsl(0, 0%, 97%)",
                "line-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "tunnel_minor",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "tunnel"],
                ["==", "class", "minor_road"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#efefef",
                "line-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 30]]
                },
                "line-dasharray": [0.36, 0.18]
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "tunnel_major",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "tunnel"],
                ["in", "class", "primary", "secondary", "tertiary", "trunk"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [[6, 0.5], [20, 30]]
                },
                "line-dasharray": [0.28, 0.14]
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "aeroway-area",
            "type": "fill",
            "source": "openmaptiles",
            "source-layer": "aeroway",
            "minzoom": 4,
            "filter": [
                "all",
                ["==", "$type", "Polygon"],
                ["in", "class", "runway", "taxiway"]
            ],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-opacity": {
                    "base": 1,
                    "stops": [[13, 0], [14, 1]]
                },
                "fill-color": "rgba(255, 255, 255, 1)"
            },
            "metadata": {
                "mapbox:group": "1444849345966.4436",
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "aeroway-taxiway",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "aeroway",
            "minzoom": 12,
            "filter": [
                "all",
                ["in", "class", "taxiway"],
                ["==", "$type", "LineString"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "rgba(255, 255, 255, 1)",
                "line-width": {
                    "base": 1.5,
                    "stops": [[12, 1], [17, 10]]
                },
                "line-opacity": 1
            },
            "metadata": {
                "mapbox:group": "1444849345966.4436",
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "aeroway-runway",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "aeroway",
            "minzoom": 4,
            "filter": [
                "all",
                ["in", "class", "runway"],
                ["==", "$type", "LineString"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "rgba(255, 255, 255, 1)",
                "line-width": {
                    "base": 1.5,
                    "stops": [[11, 4], [17, 50]]
                },
                "line-opacity": 1
            },
            "metadata": {
                "mapbox:group": "1444849345966.4436",
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_trunk_primary",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["in", "class", "trunk", "primary"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [[6, 0.5], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_secondary_tertiary",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["in", "class", "secondary", "tertiary"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [[6, 0.5], [20, 20]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_major_motorway",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "class", "motorway"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "hsl(0, 0%, 100%)",
                "line-width": {
                    "base": 1.4,
                    "stops": [[8, 1], [16, 10]]
                },
                "line-offset": 0
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "railway",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": ["==", "class", "rail"],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "line-color": "hsl(34, 12%, 66%)",
                "line-opacity": {
                    "base": 1,
                    "stops": [[11, 0], [16, 1]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "bridge_minor case",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "bridge"],
                ["==", "class", "minor_road"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#dedede",
                "line-width": {
                    "base": 1.6,
                    "stops": [[12, 0.5], [20, 10]]
                },
                "line-gap-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "bridge_major case",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "bridge"],
                ["in", "class", "primary", "secondary", "tertiary", "trunk"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": "#dedede",
                "line-width": {
                    "base": 1.6,
                    "stops": [[12, 0.5], [20, 10]]
                },
                "line-gap-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "bridge_minor",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "bridge"],
                ["==", "class", "minor_road"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#efefef",
                "line-width": {
                    "base": 1.55,
                    "stops": [[4, 0.25], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "bridge_major",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "transportation",
            "filter": [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "bridge"],
                ["in", "class", "primary", "secondary", "tertiary", "trunk"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#fff",
                "line-width": {
                    "base": 1.4,
                    "stops": [[6, 0.5], [20, 30]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "admin_sub",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "boundary",
            "filter": ["in", "admin_level", 4, 6, 8],
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "line-color": "hsl(0, 0%, 76%)",
                "line-dasharray": [2, 1]
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "admin_country",
            "type": "line",
            "source": "openmaptiles",
            "source-layer": "boundary",
            "filter": [
                "all",
                ["<=", "admin_level", 2],
                ["==", "$type", "LineString"]
            ],
            "layout": {
                "visibility": "visible",
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "hsla(0, 8%, 22%, 0.51)",
                "line-width": {
                    "base": 1.3,
                    "stops": [[3, 0.5], [22, 15]]
                }
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "poi_label",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "poi",
            "minzoom": 5,
            "filter": ["all", ["==", "$type", "Point"], ["==", "rank", 1]],
            "layout": {
                "visibility": "visible",
                "text-size": 11,
                "text-font": ["Klokantech Noto Sans Regular"],
                "text-offset": [0, 0.5],
                "icon-size": 1,
                "text-anchor": "top",
                "text-field": "{name}",
                "text-max-width": 8
            },
            "paint": {
                "text-color": "#666",
                "text-halo-width": 1,
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-blur": 1
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "road_major_label",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "transportation_name",
            "filter": ["==", "$type", "LineString"],
            "layout": {
                "visibility": "visible",
                "symbol-placement": "line",
                "text-field": "{name}",
                "text-font": ["Klokantech Noto Sans Regular"],
                "text-transform": "uppercase",
                "text-letter-spacing": 0.1,
                "text-size": {
                    "base": 1.4,
                    "stops": [[10, 8], [20, 14]]
                },
                "text-rotation-alignment": "map"
            },
            "paint": {
                "text-color": "#000",
                "text-halo-color": "hsl(0, 0%, 100%)",
                "text-halo-width": 2
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "place_label_other",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "place",
            "minzoom": 8,
            "filter": [
                "all",
                ["==", "$type", "Point"],
                ["!=", "class", "city"]
            ],
            "layout": {
                "visibility": "visible",
                "text-field": "{name}",
                "text-font": ["Klokantech Noto Sans Regular"],
                "text-max-width": 6,
                "text-size": {
                    "stops": [[6, 10], [12, 14]]
                },
                "text-anchor": "center"
            },
            "paint": {
                "text-color": "hsl(0, 10%, 25%)",
                "text-halo-color": "hsl(0, 0%, 100%)",
                "text-halo-blur": 0,
                "text-halo-width": 2
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "place_label_city",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "place",
            "maxzoom": 16,
            "filter": [
                "all",
                ["==", "$type", "Point"],
                ["==", "class", "city"]
            ],
            "layout": {
                "visibility": "visible",
                "text-field": "{name}",
                "text-font": ["Klokantech Noto Sans Regular"],
                "text-max-width": 10,
                "text-size": {
                    "stops": [[3, 12], [8, 16]]
                }
            },
            "paint": {
                "text-color": "hsl(0, 0%, 0%)",
                "text-halo-color": "hsla(0, 0%, 100%, 0.75)",
                "text-halo-blur": 0,
                "text-halo-width": 2
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        },
        {
            "id": "country_label",
            "type": "symbol",
            "source": "openmaptiles",
            "source-layer": "place",
            "maxzoom": 12,
            "filter": [
                "all",
                ["==", "$type", "Point"],
                ["==", "class", "country"]
            ],
            "layout": {
                "visibility": "visible",
                "text-field": "{name}",
                "text-font": ["Klokantech Noto Sans Bold"],
                "text-max-width": 10,
                "text-size": {
                    "stops": [[3, 12], [8, 22]]
                }
            },
            "paint": {
                "text-color": "hsl(0, 0%, 13%)",
                "text-halo-color": "rgba(255,255,255,0.75)",
                "text-halo-width": 2,
                "text-halo-blur": 0
            },
            "metadata": {
                "arbitrary_data": "",
                "layer_type": "base_map"
            }
        }
    ]
}
